import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HtmlBasicsCourse = () => {
    const { t } = useTranslation();
    const { topic } = useParams(); // Get topic parameter from URL

    // Documentation for each theme
    const content = {
        introduction: (
            <div>
                <h2>{t('htmlBasicCourse.introduction')}</h2>
                <p>{t('htmlBasicCourse.introductionContent')}</p>
                <h3>{t('htmlBasicCourse.whatIsHtml')}</h3>
                <p>{t('htmlBasicCourse.whatIsHtmlDescription')}</p>
                <h3>{t('htmlBasicCourse.basicStructure')}</h3>
                <p>{t('htmlBasicCourse.basicStructureDescription')}</p>
                <h4>{t('htmlBasicCourse.example')}</h4>
                <pre>
{`<!DOCTYPE html>
<html>
<head>
    <title>My First HTML Page</title>
</head>
<body>
    <h1>Hello World</h1>
    <p>This is my first HTML page!</p>
</body>
</html>`}
                </pre>
            </div>
        ),
        documentStructure: (
            <div>
                <h2>{t('htmlBasicCourse.documentStructure.title')}</h2>
                <p>{t('htmlBasicCourse.documentStructure.content')}</p>
                <h3>{t('htmlBasicCourse.documentStructure.heading')}</h3>
                <p>{t('htmlBasicCourse.documentStructure.description')}</p>
                <h4>{t('htmlBasicCourse.documentStructure.doctype.title')}</h4>
                <p>{t('htmlBasicCourse.documentStructure.doctype.description')}</p>
                <h4>{t('htmlBasicCourse.documentStructure.htmlTag.title')}</h4>
                <p>{t('htmlBasicCourse.documentStructure.htmlTag.description')}</p>
                <h4>{t('htmlBasicCourse.documentStructure.headTag.title')}</h4>
                <p>{t('htmlBasicCourse.documentStructure.headTag.description')}</p>
                <h4>{t('htmlBasicCourse.documentStructure.bodyTag.title')}</h4>
                <p>{t('htmlBasicCourse.documentStructure.bodyTag.description')}</p>
            </div>
        ),
        commonTags: (
            <div>
                <h2>{t('htmlBasicCourse.commonTags.title')}</h2>
                <p>{t('htmlBasicCourse.commonTags.content')}</p>
                <h3>{t('htmlBasicCourse.commonTags.commonHtmlTags')}</h3>
                <ul>
                    <li><strong>&lt;h1&gt; to &lt;h6&gt;</strong>: {t('htmlBasicCourse.commonTags.headerTags')}</li>
                    <li><strong>&lt;p&gt;</strong>: {t('htmlBasicCourse.commonTags.paragraphTag')}</li>
                    <li><strong>&lt;a&gt;</strong>: {t('htmlBasicCourse.commonTags.anchorTag')}</li>
                    <li><strong>&lt;img&gt;</strong>: {t('htmlBasicCourse.commonTags.imageTag')}</li>
                    <li><strong>&lt;ul&gt;</strong> and <strong>&lt;li&gt;</strong>: {t('htmlBasicCourse.commonTags.listTags')}</li>
                </ul>
                <h4>{t('htmlBasicCourse.example')}</h4>
                <pre>
{`<h1>My Website</h1>
<p>Welcome to my website.</p>
<a href="https://www.example.com">Visit Example</a>
<img src="image.jpg" alt="An example image">
<ul>
    <li>Item 1</li>
    <li>Item 2</li>
</ul>`}
                </pre>
            </div>
        ),
        linksImages: (
            <div>
                <h2>{t('htmlBasicCourse.linksImages.title')}</h2>
                <p>{t('htmlBasicCourse.linksImages.content')}</p>
                <h3>{t('htmlBasicCourse.linksImages.addingLinksImages')}</h3>
                <h4>{t('htmlBasicCourse.linksImages.links.title')}</h4>
                <p>{t('htmlBasicCourse.linksImages.links.description')}</p>
                <pre>
{`<a href="https://www.example.com">Visit Example</a>`}
                </pre>
                <h4>{t('htmlBasicCourse.linksImages.images.title')}</h4>
                <p>{t('htmlBasicCourse.linksImages.images.description')}</p>
                <pre>
{`<img src="image.jpg" alt="An example image">`}
                </pre>
            </div>
        ),
        formsInput: (
            <div>
                <h2>{t('htmlBasicCourse.formsInput.title')}</h2>
                <p>{t('htmlBasicCourse.formsInput.content')}</p>
                <h3>{t('htmlBasicCourse.formsInput.formsIntro')}</h3>
                <p>{t('htmlBasicCourse.formsInput.formsDescription')}</p>
                <h4>{t('htmlBasicCourse.formsInput.example')}</h4>
                <pre>
{`<form action="/submit-form" method="post">
    <label for="name">Name:</label>
    <input type="text" id="name" name="name">
    
    <label for="email">Email:</label>
    <input type="email" id="email" name="email">
    
    <input type="submit" value="Submit">
</form>`}
                </pre>
                <h4>{t('htmlBasicCourse.formsInput.commonInputTypes')}</h4>
                <ul>
                    <li><strong>text</strong>: {t('htmlBasicCourse.formsInput.inputTypes.text')}</li>
                    <li><strong>email</strong>: {t('htmlBasicCourse.formsInput.inputTypes.email')}</li>
                    <li><strong>password</strong>: {t('htmlBasicCourse.formsInput.inputTypes.password')}</li>
                    <li><strong>submit</strong>: {t('htmlBasicCourse.formsInput.inputTypes.submit')}</li>
                </ul>
            </div>
        )
    };

    return (
        <div className="container mt-5">
            {/* Render content based on the selected topic */}
            {content[topic] || <p>{t('htmlBasicCourse.notFound')}</p>}
        </div>
    );
};

export default HtmlBasicsCourse;
